import { theme } from '@capturi/ui-theme'

export default function createStyle(className: string): string {
  return `
    /* Root */
    .${className}.rdp-root {
      font-size: inherit;
      margin-top: 0;
      /* Remove default selected border var */
      --rdp-selected-border: none;
    }
    /* Month grid */
    .${className} .rdp-month_grid {
      margin-top: ${theme.space[2]};
      border-collapse: collapse;
      border-spacing: 0;
    }
    /* Weekday header cells */
    .${className} .rdp-weekday {
      font-weight: 400;
      font-size: 0.875em;
      color: ${theme.colors.greys[300]};
      text-transform: none;
    }
    /* Day buttons */
    .${className} .rdp-day_button {
      width: 35px;
      height: 35px;
      border-radius: 0;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .${className} .rdp-day_button:focus {
      outline: 0;
    }
    /* Day cells */
    .${className} .rdp-day {
      width: 35px;
      height: 35px;
      padding: 0;
      border: none;
    }
    /* Range middle */
    .${className} .rdp-range_middle:not(.rdp-outside):not(.rdp-range_start):not(.rdp-range_end) {
      background-color: ${theme.colors.primary[500]};
      color: ${theme.colors.white};
    }
    .${className} .rdp-range_middle:not(.rdp-outside):not(.rdp-range_start):not(.rdp-range_end) .rdp-day_button {
      background-color: ${theme.colors.primary[500]};
      color: ${theme.colors.white};
      font-weight: 400;
      font-size: 14px;
    }
    /* Hide built-in nav (we render our own inside MonthCaption) */
    .${className} .rdp-nav {
      display: none;
    }
    /* Selected day */
    .${className} .rdp-selected:not(.rdp-disabled):not(.rdp-outside) .rdp-day_button {
      background-color: ${theme.colors.primary[500]};
      color: ${theme.colors.white};
      border: none;
      font-weight: 400;
      font-size: 14px;
    }
    .${className} .rdp-selected:not(.rdp-disabled):not(.rdp-outside) .rdp-day_button:hover {
      background-color:${theme.colors.primary[600] ?? theme.colors.primary[500]};
      color: ${theme.colors.white};
      border: none;
    }
    /* Hover state */
    .${className} .rdp-day_button:not(.rdp-disabled):not(.rdp-selected):not(.rdp-outside):hover {
      background-color: ${theme.colors.primary[300]};
    }

    /* Today */
    .${className} .rdp-today:not(.rdp-selected) .rdp-day_button {
      color: ${theme.colors.primary[500]};
      border: none;
    }
  `
}
